export const PORTAL_URL = 'https://nashsever51.ru/';
